// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import {HelpPanel} from '@cloudscape-design/components';

const PlaceholderHelp = () => {
    return (
        <HelpPanel header={<h2>Work in progress</h2>}>
            <div>
                <p>
                    We are still building the help panel content for this page.
                    It will be available soon.
                </p>
            </div>
        </HelpPanel>
    );
};

export default PlaceholderHelp;
